import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { withContext } from 'admin/components/common/withContext'
import checkAdminAccess from 'admin/functions/checkAdminAccess'
import { State } from 'admin/redux/ducks'
import { FeatureToggleState } from 'admin/redux/ducks/featureToggle'
import { AdminTypes, ConfigType, LoginType } from 'types'

const SecureRoute: React.FC<SecureRouteProps> = ({
  secure = false,
  access,
  mmbAdmin = false,
  toggledByFeature,
  config,
  children,
  login,
}) => {
  const location = useLocation()
  const featureToggleState = useSelector(
    (state: State) => state.featureToggle as FeatureToggleState
  )
  let actualRender: React.ReactNode = null
  if (
    toggledByFeature &&
    featureToggleState.data &&
    featureToggleState.data[toggledByFeature] &&
    featureToggleState.data[toggledByFeature].toLowerCase().includes('off')
  ) {
    actualRender = <Navigate {...config.locations.pageNotFound} />
  }

  if (secure) {
    if (!login || (login && !login.isLoggedIn)) {
      const redirect = location.pathname ? `&redirect=${location.pathname}` : ''
      actualRender = (
        <Navigate
          to={{
            search: `clientId=${config.keycloak.clientIds.bankId}${redirect}`,
            pathname: config.locations.login.to as string
          }}
          replace
        />
      )
    }
  }
  
  if (access) {
    if (!checkAdminAccess(login.administratorType, access)) {
      actualRender = <Navigate {...config.locations.accessDenied} replace />
    }
  }

  if (mmbAdmin) {
    if (!login || (login && !login.isLoggedIn)) {
      actualRender = (
        <Navigate
          to={{
            pathname: config.locations.login.to as string,
            search: `clientId=${
              config.keycloak.clientIds.userNamePass
            }&${location.search.substring(1)}`,
          }}
          replace
        />
      )
    }
  }

  if (!actualRender) {
    actualRender = children
  }

  return <>{actualRender}</>
}

type SecureRouteProps = {
  secure?: boolean
  login?: LoginType
  access?: AdminTypes
  mmbAdmin: boolean
  toggledByFeature?: string
  config: ConfigType
  children: React.ReactNode
}

export default withContext(SecureRoute)
